import { ITile } from '../features/Analyse/slice/@types/ITile'
import { ISectionTile } from '../features/Analyse/slice/@types/ISectionTile'

export const getTileInfo = (tileId: string, category: string, values: ISectionTile[]): ITile | undefined =>
  values.find(c => c.id === category)?.tiles.find(t => t.id === tileId)
